module.exports = __webpack_public_path__ + "colour-image.7e98aa4d8e0ed8e165f0.png";